import { Record, Map } from "immutable"

import {
    toUI as defaultToUI,
    updateChangeModel,
    updateCreateModel,
} from "../model-utils"
import moment from "moment"

import { notificationTypes } from "../../config/application-definitions"
import { getNotificationFutureDate } from "../../components/notifications/util"

export const NotificationModelRecord = new Record({
    id: "",
    type: Object.keys(notificationTypes)[0],
    message: "",
    title: "",
    not_before: getNotificationFutureDate(),
    expires: null,
    time_set: moment(),
    link: "",
    entity_id: "",
    context: {},
    send_push: true,
    notification_triggered: false,
})
export const NotificationModel = (data) => {
    let notificationModel = new NotificationModelRecord(data)
    if (!data) {
        notificationModel = notificationModel
            .set("not_before", getNotificationFutureDate())
            .set("time_set", moment())
    }
    return notificationModel
}

export function NotificationCreateModel() {
    return Map({
        type: Object.keys(notificationTypes)[0],
        message: "",
        title: "",
        not_before: getNotificationFutureDate().unix(),
        time_set: moment().unix(),
        send_push: true,
    })
}

const dateFields = ["not_before", "expires", "time_set"]
const tagFields = []
export const normalisingFields = []
const addRemoveFields = []

export const normalise = (notification) => notification
export const hydrate = (notification, ...entityStates) => notification

export const updateNotificationChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) =>
    updateChangeModel(
        name,
        value,
        changeModel,
        workingModel,
        addRemoveFields,
        dateFields
    )

export const updateNotificationCreateModel = (
    name,
    value,
    createModel,
    workingModel
) =>
    updateCreateModel(
        name,
        value,
        createModel,
        workingModel,
        addRemoveFields,
        dateFields
    )

export const toUI = (notification) => {
    const model = defaultToUI(notification, dateFields, tagFields)
    const context = notification.get("context") || {}
    return model
        .set("link", (context && context.link) || "")
        .set("entity_id", (context && context.entity_id) || "")
}
